// TODO: integrare firma digitale (Yousign o DocuSign) — Sprint 4
import { PenTool } from 'lucide-react';

const CARD_SHADOW = '0 6px 18px rgba(35,38,47,0.08)';
const tint = (c, pct) => `color-mix(in srgb, ${c} ${pct}%, transparent)`;

export default function FirmaDigitaleModal({ documento, onClose }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'var(--ds-bg)', borderRadius: 'var(--radius-card)', width: '100%', maxWidth: 400, boxShadow: CARD_SHADOW, padding: '40px 32px', textAlign: 'center' }}>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}><PenTool size={64} color="var(--brand)" strokeWidth={2} /></div>
        <h2 style={{ margin: '0 0 10px', fontSize: 18, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>Firma digitale disponibile a breve</h2>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: 'var(--ds-muted)', lineHeight: 1.6 }}>
          Potrai far firmare contratti e preventivi direttamente online, senza stampa.
        </p>
        <div style={{ display: 'inline-block', background: tint('var(--zone-blue)', 10), color: 'var(--zone-blue)', padding: '6px 14px', borderRadius: 999, fontSize: 11, fontWeight: 500, marginBottom: 24 }}>
          Disponibile nei piani Business e Pro · In sviluppo
        </div>
        <div>
          <button onClick={onClose} style={{ padding: '10px 24px', borderRadius: 'var(--radius-base)', border: 'none', background: 'var(--brand)', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}
